import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { ITransaction, ITransactionForm } from "../../data/entities";
import { TransactionRepoImpl } from "../../data/repo";

export const transactionRedux = generateCrudRedux<ITransaction, ITransactionForm>({
  actionTypeName: "Transaction",
  repository: TransactionRepoImpl,
});

export interface ITransactionReduxState extends ICRUDReduxState<ITransaction> {}

export const TransactionReducers = combineReducers<ITransactionReduxState>({
  ...transactionRedux.reducer,
});
